import { Modal, ModalHeader } from "reactstrap";
import { H3, P } from "../../../../../AbstractElements";
import UploadProfileForm from "./UploadProfileForm";

interface ModalProps {
  ApplNo: string;
  modal: boolean;
  toggle?: () => void;
}

const UploadProfileModal: React.FC<ModalProps> = ({
  ApplNo,
  modal,
  toggle,
}) => {
  return (
    <>
        <Modal isOpen={modal} toggle={toggle} backdrop="static" keyboard={false}>
          <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
            <ModalHeader className="large-modal-header border-0">
              <H3>Upload Applicant Profile</H3>
              <button onClick={toggle} className="btn-close"></button>
              <P>Upload a clear and updated applicant photo.</P>
            </ModalHeader>

            <UploadProfileForm ApplNo={ApplNo} toggle={toggle} />
            
          </div>
        </Modal>
    </>
  );
};

export default UploadProfileModal;
